import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 11L12 6L9.5 11L6 9.15731L6.85424 14.3222C7.01158 15.2734 7.09024 15.7491 7.32718 16.106C7.53603 16.4207 7.82971 16.6698 8.17423 16.8245C8.56508 17 9.04717 17 10.0114 17H13.9886C14.9528 17 15.4349 17 15.8258 16.8245C16.1703 16.6698 16.464 16.4207 16.6728 16.106C16.9098 15.7491 16.9884 15.2734 17.1458 14.3222L18 9.15731L14.5 11Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	})
});
export default SvgCrown;
